import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import classes from './ListItem.css';
import Arrow from '../../Arrow/Arrow';

const composeItemTitle = title => {
  const numericPart = title.substr(0, title.indexOf(' '));
  const textPart = ` ${title.substr(title.indexOf(' ') + 1)}`;
  const titleElement = (
    <Fragment>
      <span>{numericPart}</span>
      <span style={{ fontWeight: 'normal' }}>{textPart}</span>
    </Fragment>
  );

  return titleElement;
};

const listItem = props => {
  const { selected, title } = props;
  return (
    <li className={classes.ListItem} onClick={selected} onKeyDown={selected}>
      <h2>{composeItemTitle(title)}</h2>
      <Arrow direction="next" />
    </li>
  );
};

composeItemTitle.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.func
};

export default listItem;
